import {
    INIT_GROUP,
} from 'redux/group/actions'

export const group = (state = {}, {type, group}) => {

    switch (type)
    {
        case INIT_GROUP:
            return {...group}
        default:
            return state
    }
}
